import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { SelectPlayerImg } from "@app/core/match/domain/model/select-player-img";
import { PlayerIdentificationData } from "@app/core/match/domain/model/player-identification-data";
import { PlayerIdentificationMapper } from "@app/core/match/data/network/player-identification.mapper";

@Injectable({
  providedIn: "root",
})
export class PlayerIdentificationInformationWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(
    match_code: string,
    token: string
  ): Observable<PlayerIdentificationData> {
    const parameters = new HandlerBuilder()
      .setMethod(HttpMethod.get)
      .setUrl(
        ApiUrls.GET_PLAYER_IDENTIFICATION_INFORMATION_ENDPOINT(match_code)
      )
      .setAuthorization(new TokenAuthorization(token))
      .build();

    return this.baseHandler.execute(parameters).pipe(
      map((response) => PlayerIdentificationMapper.deserialize(response)),
    );
  }
}
